import { useCallback } from 'react'
import { usePostHog } from 'posthog-js/react'

// Thin wrapper around PostHog capture. No-ops when the client is unavailable
// (e.g. no API key configured), matching the provider's no-key tolerance.
export const useTrackEvent = () => {
  const posthog = usePostHog()

  return useCallback(
    (name: string, properties?: Record<string, unknown>) => {
      posthog?.capture(name, properties)
    },
    [posthog]
  )
}
